import { Button } from "@/components/ui/button";
import { LucideAlertTriangle } from "lucide-react";
import { Modal } from "@/components/modals/Modal";

/**
 * Confirmation modal shown when the user attempts to navigate away from a
 * form with unsaved changes via in-app routing. Replaces the default browser
 * confirm dialog. Browser-level page exits (refresh, tab close) still use the
 * native beforeunload prompt since browsers don't permit custom UI there.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onStay - User chose to stay on the page
 * @param {() => void} props.onLeave - User chose to leave (caller decides whether to save first)
 */
export function UnsavedChangesModal({ open, onStay, onLeave }) {
  return (
    <Modal
      open={open}
      onClose={onStay}
      title="Unsaved changes"
      subtitle="You have changes that haven't been saved yet."
      icon={<LucideAlertTriangle size={16} className="text-warning-fg" />}
      maxWidth="max-w-sm"
      zIndex={60}
    >
      <div className="px-6 py-5 space-y-4">
        <p className="text-sm text-muted-foreground">
          If you leave now, your most recent edits may not be saved. Stay on the page to let auto-save finish, or leave anyway.
        </p>
        <div className="flex gap-2 pt-1">
          <Button variant="default" onClick={onStay}>
            Stay on page
          </Button>
          <Button variant="outline" onClick={onLeave}>
            Leave anyway
          </Button>
        </div>
      </div>
    </Modal>
  );
}
